import * as React from 'react';

import { useParams } from 'js/lib/useRouter';

import { degreeIsPartOfV3 } from 'bundles/degree-home/components/v3-dpm/lib/otherUtils';
import useDegreePlanProperties from 'bundles/degree-home/components/v3-dpm/lib/useDegreePlanPropertiesBySlug';

type DegreePlanPropertiesContextType = {
  isDPMEnabled: boolean | undefined;
  loading?: boolean;
};

const DegreePlanPropertiesContext = React.createContext<DegreePlanPropertiesContextType | undefined>(undefined);

export const useDegreePlanPropertiesContext = () => {
  const context = React.useContext(DegreePlanPropertiesContext);
  if (context === undefined) {
    throw new Error('useDegreePlanPropertiesContext must be used within a DegreePlanPropertiesContextProvider');
  }
  return context;
};

const DegreePlanPropertiesContextProvider: React.LegacyFunctionComponentWithChildren = ({ children }) => {
  const { degreeSlug } = useParams();
  // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  const { data, loading, error } = useDegreePlanProperties(degreeSlug, false);

  let isDPMEnabled: boolean | undefined;
  if (error) {
    isDPMEnabled = false;
  } else if (data && !loading) {
    isDPMEnabled = degreeIsPartOfV3(data.Degree?.queryBySlug);
  }

  return (
    <DegreePlanPropertiesContext.Provider value={{ isDPMEnabled, loading }}>
      {children}
    </DegreePlanPropertiesContext.Provider>
  );
};

export default DegreePlanPropertiesContextProvider;
